var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.1665 4.16602C4.1665 2.7853 5.28579 1.66602 6.6665 1.66602H13.3332C14.7139 1.66602 15.8332 2.7853 15.8332 4.16602V15.8327C15.8332 17.2134 14.7139 18.3327 13.3332 18.3327H6.6665C5.28579 18.3327 4.1665 17.2134 4.1665 15.8327V4.16602Z",
    stroke: "#074EE8",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49984 1.66602H12.4998V2.08268C12.4998 3.00316 11.7536 3.74935 10.8332 3.74935H9.1665C8.24603 3.74935 7.49984 3.00316 7.49984 2.08268V1.66602Z",
    stroke: "#074EE8",
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0083 15L9.99997 15",
    stroke: "#074EE8",
    strokeWidth: 2.08333,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.ee8ed9fa6c105c1ad9a22af4ae7eec9b.svg";
export { ForwardRef as ReactComponent };